var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgAmericanExpress = function SvgAmericanExpress(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1057 0H2.16497C1.06368 0 0.170898 0.89543 0.170898 2V14C0.170898 15.1046 1.06368 16 2.16497 16H22.1057C23.207 16 24.0998 15.1046 24.0998 14V2C24.0998 0.89543 23.207 0 22.1057 0Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.894 13.3939V7.6925L24.0115 7.70161V9.27651L22.8421 10.5299L24.0115 11.7948V13.4031H22.1444L21.1522 12.3049L20.167 13.4072L13.894 13.3939Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5698 12.7688V8.31995H18.3309V9.34483H15.7876V10.0405H18.2703V11.0483H15.7876V11.7317H18.3309V12.7688H14.5698Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3121 12.7687L20.3933 10.5417L18.312 8.31995H19.9229L21.1946 9.72998L22.4699 8.31995H24.0115V8.35495L21.9747 10.5417L24.0115 12.7056V12.7687H22.4544L21.1601 11.3446L19.8792 12.7687H18.3121Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3662 2.63196H16.805L17.6616 4.58281V2.63196H20.6725L21.1917 4.09353L21.7126 2.63196H24.0117V8.33335H11.8613L14.3662 2.63196Z",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.828 3.25134L12.8599 7.69651H14.2098L14.5811 6.80635H16.593L16.9641 7.69651H18.3476L16.3876 3.25134H14.828ZM14.9972 5.80878L15.5874 4.39371L16.1772 5.80878H14.9972Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3291 7.69569V3.25061L20.2266 3.25715L21.203 5.98988L22.1857 3.25061H24.0118V7.69569L22.8367 7.70612V4.65278L21.7274 7.69569H20.6548L19.5226 4.64235V7.69569H18.3291Z",
    fill: "#016FD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9289,
    height: 16,
    fill: "white",
    transform: "translate(0.170898)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgAmericanExpress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/American-Express.084d85713e72407ac2735f90d30f6284.svg";